import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { CreditStatusNotice } from '../components/CreditStatusNotice';
import { routeNames } from '../constants/routes';

const Overlay = styled.div`
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.55);
    backdrop-filter: blur(1.5px);
    -webkit-backdrop-filter: blur(1.5px);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* Antd Card creates a stacking context, so overlay needs a high z-index to win.
       isolation on the parent SectionModeCardsRelative could also help, but a
       generous z-index is the simpler fix. */
    z-index: 100;
    animation: fadeIn 0.4s ease;
    pointer-events: auto;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

interface DisabledSectionOverlayProps {
    resumeDate: string;
}

export const DisabledSectionOverlay: React.FC<DisabledSectionOverlayProps> = ({ resumeDate }) => (
    <Overlay role="status" aria-live="polite">
        <CreditStatusNotice
            title="Kredity vyčerpány"
            tone="danger"
            align="center"
            action={<Link to={`/${routeNames.endIsNear}`}>Proč jsou kredity vyčerpány?</Link>}
            footer="Mezitím si můžeš vyzkoušet kvízy a hry pod touto sekcí ↓"
            style={{ maxWidth: 460, width: 'calc(100% - 40px)' }}
        >
            Panoramata teď ve hře nefungují. Hra poběží zase od <strong>{resumeDate}</strong>.
        </CreditStatusNotice>
    </Overlay>
);
